import * as React from 'react';
import { useInView } from 'react-intersection-observer';

import { ImagePlaceholder } from '@notino/react-styleguide';

import { useTrackingContext } from '@context/tracking/TrackingContext';
import { useOnTap } from '@hooks/useOnTap';

import { useNewPdDesignEnabled } from '../../hooks/useNewPdDesignEnabled';
import { trackProductImageTap } from '../tracking';

import { ImgWrapper } from './styled';

import { IImageSliderProps } from '.';

interface Props {
  initialInView?: boolean;
  imgProps: IImageSliderProps['imagesAttrs'][number];
}

export const ResizableImagePlaceholder: React.FC<
  React.PropsWithChildren<Props>
> = ({ imgProps, children, initialInView = false }) => {
  const newPdDesign = useNewPdDesignEnabled();
  const [isSquare, setIsSquare] = React.useState(false);
  const [inViewRef, inView] = useInView({ initialInView, triggerOnce: true });

  const { getTimeFromInit } = useTrackingContext();
  const onTapRef = useOnTap<HTMLDivElement>(() =>
    trackProductImageTap({ timing: getTimeFromInit() })
  );

  const handleImageLoad = (elem: HTMLImageElement) => {
    setIsSquare(
      elem.naturalWidth === elem.naturalHeight &&
        !initialInView &&
        !imgProps.src.includes('-o/')
    );
  };

  const handleRef = (node: HTMLDivElement) => {
    onTapRef.current = node;
    inViewRef(node);
  };

  return (
    <ImgWrapper ref={handleRef} newPdDesign={newPdDesign} isSquare={isSquare}>
      {inView && (
        <ImagePlaceholder
          // Don't display placeholder for the first image in the slider.
          // An image replace placeholder when is loaded and after react is hydrated.
          // React hydration can take some time and we want first image to show immediately when loaded.
          hidePlaceholder={initialInView}
          image={imgProps}
          onLoad={handleImageLoad}
        />
      )}
      {children}
    </ImgWrapper>
  );
};
